import React from 'react'

function DisplayField({label, value}) {
  return (
    <div className='input-field-container'>
      <div className='label'>{label}</div>
      <div>{value}</div>
    </div>
  )
}

export default DisplayField
